import user from "../User/Infrastructure/User.reducer";
import businessPartner from "../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import zone from "../Zones/Infrastructure/Zone.reducer";

const reducer = { user, businessPartner, zone };

export default reducer;
